export const firebaseConfig = {
    apiKey: "AIzaSyCK9_Yg29NU1ciAepw6i_D6dyoQcOz60e0",
    authDomain: "lftovrs-4ee17.firebaseapp.com",
    projectId: "lftovrs-4ee17", 
    storageBucket: "lftovrs-4ee17.appspot.com",
    messagingSenderId: "334924504780",  
    appId: "1:334924504780:web:bde8d6e9ecfb03464e6c69"  
};
